var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEsGa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icon-css-es-ga",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g5162",
    fontSize: 12,
    transform: "matrix(.85333 0 0 1.2801 0 -123)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect733",
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "evenodd",
    strokeWidth: "1pt",
    d: "M0 96h600v400H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path556",
    fill: "#09c",
    d: "M600 437.8L86 96H0v57l516 343h84v-58.2"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "g4979",
    fontSize: 12,
    transform: "matrix(1.13778 0 0 1.13875 -85.4 -81.1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path558",
    fill: "#005bbf",
    fillOpacity: 1,
    d: "M296.6 401.2c-60 0-58.1-56.5-58.1-56.5v-86.9h116.3v86.9s2 56.5-58.2 56.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path559",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1,
    d: "M296.6 401.2c-60 0-58.1-56.5-58.1-56.5v-86.9h116.3v86.9s2 56.5-58.2 56.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path560",
    fill: "#d81126",
    fillOpacity: 1,
    d: "M296.1 203.2s-12.4-6-24.1 2.8c0 0-21.1-3-22.7 17.2 0 .8-.2 2.3.2 2.8.4.4.8 1.2.8 1.8 0 .6.3.9.5 1.1 0 .3.4.7.5 1.7 0 1.1-.2 1.6.9 2.7 1 1 1 4.1 1 5 0 .9.6 3.3 1 3.8.5.5 1.3 1.8 1.3 2.9 0 1 .4 4 .2 4.7-.2.8 1.2 1.7 2.4 2.1 1.2.4 16 5.2 37.6 4.8 21.6-.3 29.4-1.5 38.4-4.7 1.3-.5 1.6-1.7 1.5-2.3-.2-.6 0-2.6.3-3.1.4-.5 3-4.6 2.4-5.3-.5-.8-.5-2.4 0-3 .5-.7 2.1-3.7 2.4-5 .3-1.2.4-2.7 1-3.1.5-.4.7-1.9.8-2.2a4 4 0 011.2-1.6s1-5.1.4-7.6c-.7-2.5-4.5-13.3-19.8-11 0 0-11.4-8.7-28.2-4.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path561",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.5,
    d: "M296.1 203.2s-12.4-6-24.1 2.8c0 0-21.1-3-22.7 17.2 0 .8-.2 2.3.2 2.8.4.4.8 1.2.8 1.8 0 .6.3.9.5 1.1 0 .3.4.7.5 1.7 0 1.1-.2 1.6.9 2.7 1 1 1 4.1 1 5 0 .9.6 3.3 1 3.8.5.5 1.3 1.8 1.3 2.9 0 1 .4 4 .2 4.7-.2.8 1.2 1.7 2.4 2.1 1.2.4 16 5.2 37.6 4.8 21.6-.3 29.4-1.5 38.4-4.7 1.3-.5 1.6-1.7 1.5-2.3-.2-.6 0-2.6.3-3.1.4-.5 3-4.6 2.4-5.3-.5-.8-.5-2.4 0-3 .5-.7 2.1-3.7 2.4-5 .3-1.2.4-2.7 1-3.1.5-.4.7-1.9.8-2.2a4 4 0 011.2-1.6s1-5.1.4-7.6c-.7-2.5-4.5-13.3-19.8-11 0 0-11.4-8.7-28.2-4.5h0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path562",
    fill: "#bcac0b",
    fillOpacity: 1,
    d: "M337.6 240.8c-47-14.9-83.4-.7-83.4-.7s.4 1.6.8 2.1 1 1.7 1 2.6v2.8c0 .7-.4 3.7 2.2 3.6 0 0 32.8-12.8 75.4.7 0 0 1.2-1 1.2-2.5a8 8 0 011-4c.5-.8 1.8-3.4 1.8-4.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path563",
    fill: "#c8b100",
    fillOpacity: 0.9,
    d: "M294 319.3h-20.5s-2 18.3 13.8 23.9v1.6h3.3v2.2s-5.8 5.2-.7 11.2v1.8h.8v3h1v4.7s-.8 17-17.6 25.2v1h44.7v-1c-16.7-8.1-17.5-25.2-17.5-25.2V363h1V360h.8v-1.8c5-6-.8-11.2-.8-11.2v-2.2h3.4v-1.6c15.7-5.6 13.7-23.9 13.7-23.9H294"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path564",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1,
    d: "M294 319.3h-20.5s-2 18.3 13.8 23.9v1.6h3.3v2.2s-5.8 5.2-.7 11.2v1.8h.8v3h1v4.7s-.8 17-17.6 25.2v1h44.7v-1c-16.7-8.1-17.5-25.2-17.5-25.2V363h1V360h.8v-1.8c5-6-.8-11.2-.8-11.2v-2.2h3.4v-1.6c15.7-5.6 13.7-23.9 13.7-23.9H294h0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path565",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M286.6 342.9h19.7m-19 1.5h18.4m-15 2.5h11.5m-12.3 11.5H303m-12.4 1.4h11.6m-11.6 2.8h11.5m-18.5 23.2h25.5m-32.7 5.9h40m-41.5.9h43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path566",
    fill: "#ccc",
    fillOpacity: 1,
    d: "M296.6 318.3a13 13 0 100-26.1 13 13 0 000 26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path567",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1,
    d: "M296.6 318.3a13 13 0 100-26.1 13 13 0 000 26z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path568",
    fill: "#ccc",
    fillOpacity: 1,
    d: "M266.3 280h-8.1v-8.2H251v8.2h-8.2v7.2h8.2v8h7.2v-8h8V280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path569",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1,
    d: "M266.3 280h-8.1v-8.2H251v8.2h-8.2v7.2h8.2v8h7.2v-8h8V280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path570",
    fill: "#ccc",
    fillOpacity: 1,
    d: "M350.8 280h-8.1v-8.2h-7.2v8.2h-8.2v7.2h8.2v8h7.2v-8h8.1V280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path571",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1,
    d: "M350.8 280h-8.1v-8.2h-7.2v8.2h-8.2v7.2h8.2v8h7.2v-8h8.1V280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path572",
    fill: "#ccc",
    fillOpacity: 1,
    d: "M308 269.7h-8.2v-8h-7.2v8h-8v7.2h8v8.2h7.2v-8.2h8.2v-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path573",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1,
    d: "M308 269.7h-8.2v-8h-7.2v8h-8v7.2h8v8.2h7.2v-8.2h8.2v-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path574",
    fill: "#ccc",
    fillOpacity: 1,
    d: "M266.3 315.2h-8.1V307H251v8.2h-8.2v7.2h8.2v8h7.2v-8h8v-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path575",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1,
    d: "M266.3 315.2h-8.1V307H251v8.2h-8.2v7.2h8.2v8h7.2v-8h8v-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path576",
    fill: "#ccc",
    fillOpacity: 1,
    d: "M350.8 315.2h-8.1V307h-7.2v8.2h-8.2v7.2h8.2v8h7.2v-8h8.1v-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path577",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1,
    d: "M350.8 315.2h-8.1V307h-7.2v8.2h-8.2v7.2h8.2v8h7.2v-8h8.1v-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path578",
    fill: "#ccc",
    fillOpacity: 1,
    d: "M266.3 350.7h-8.1v-8.1H251v8.1h-8.2v7.2h8.2v8.1h7.2v-8h8v-7.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path579",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1,
    d: "M266.3 350.7h-8.1v-8.1H251v8.1h-8.2v7.2h8.2v8.1h7.2v-8h8v-7.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path580",
    fill: "#ccc",
    fillOpacity: 1,
    d: "M350.8 350.7h-8.1v-8.1h-7.2v8.1h-8.2v7.2h8.2v8.1h7.2v-8h8.1v-7.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path581",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1,
    d: "M350.8 350.7h-8.1v-8.1h-7.2v8.1h-8.2v7.2h8.2v8.1h7.2v-8h8.1v-7.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path582",
    fill: "#005bbf",
    fillOpacity: 1,
    d: "M296.5 185.8a7.8 7.8 0 100-15.7 7.8 7.8 0 000 15.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path583",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1,
    d: "M296.5 185.8a7.8 7.8 0 100-15.7 7.8 7.8 0 000 15.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path584",
    fill: "#fc0",
    fillOpacity: 1,
    d: "M303.8 176.6h-6.4v-10.4h2.5v-2h-2.5v-2.5h-2v2.4h-2.5v2.1h2.4v10.4h-6v1.4h14.5v-1.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path585",
    fill: "#bcac0b",
    fillOpacity: 1,
    stroke: "#000",
    strokeWidth: 0.5,
    d: "M303.8 176.6h-6.4v-10.4h2.5v-2h-2.5v-2.5h-2v2.4h-2.5v2.1h2.4v10.4h-6v1.4h14.5v-1.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path586",
    fill: "#fc0",
    fillOpacity: 1,
    d: "M265.2 195.1s5.8-.6 9.1.7c0 0-3.8 4.4-3 10.1.4 3 1 4.5 1.9 6 .8 1.3 1.7 4.3 1.2 6.6h1.1s1.1-4.8-.7-7.4a10 10 0 01-1-10.3c1.9-3.8 4.6-5.3 4.6-5.3 3 1.2 9.6 0 11.4-1.3 1.9-1.3 2.8-3.2-.6-3.3-3.5-.2-9.3-.1-13.3 2.9 0 0-2.1-2.4-12.6-1.3-10.5 1.2-18 5.7-20.4 15.1-1.2 4.8 3.3 14.9 7.4 17.3 0 0-.1-1.6.3-2.8 0 0-7-7.9-5-15.2 2.2-7.2 10.6-12 19.6-11.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path587",
    fill: "#bcac0b",
    fillOpacity: 1,
    stroke: "#000",
    strokeWidth: 0.7,
    d: "M265.2 195.1s5.8-.6 9.1.7c0 0-3.8 4.4-3 10.1.4 3 1 4.5 1.9 6 .8 1.3 1.7 4.3 1.2 6.6h1.1s1.1-4.8-.7-7.4a10 10 0 01-1-10.3c1.9-3.8 4.6-5.3 4.6-5.3 3 1.2 9.6 0 11.4-1.3 1.9-1.3 2.8-3.2-.6-3.3-3.5-.2-9.3-.1-13.3 2.9 0 0-2.1-2.4-12.6-1.3-10.5 1.2-18 5.7-20.4 15.1-1.2 4.8 3.3 14.9 7.4 17.3 0 0-.1-1.6.3-2.8 0 0-7-7.9-5-15.2 2.2-7.2 10.6-12 19.6-11.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path588",
    fill: "#fff",
    d: "M284.9 193.7c1.8-.2 3.3-.5 3.2-.7 0-.3-1.5-.3-3.3-.2-1.8.1-3.2.5-3.2.7 0 .3 1.5.3 3.3.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path589",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.7,
    d: "M278.3 195.4s-2 2 0 0 6.4-3.2 8.9-2.7c2.4.6-.5.9-1.3 1-.8 0-2.4.3-4.8 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path590",
    fill: "#fc0",
    fillOpacity: 1,
    d: "M327.7 195.8s-5.7-.7-9.1.6a14.6 14.6 0 011.2 16c-.9 1.5-1.8 4.4-1.3 6.7h-1s-1.2-4.7.7-7.4a10 10 0 00.9-10.2 12.6 12.6 0 00-4.5-5.4c-3.1 1.3-9.7 0-11.5-1.3-1.8-1.3-2.8-3.1.7-3.3 3.4-.2 9.3-.1 13.3 3 0 0 2-2.5 12.6-1.3 10.4 1.1 18 5.6 20.3 15 1.2 4.8-3.2 14.9-7.3 17.3 0 0 0-1.6-.3-2.8 0 0 7-7.8 4.9-15.1-2.1-7.3-10.5-12-19.6-11.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path591",
    fill: "#bcac0b",
    fillOpacity: 1,
    stroke: "#000",
    strokeWidth: 0.7,
    d: "M327.7 195.8s-5.7-.7-9.1.6a14.6 14.6 0 011.2 16c-.9 1.5-1.8 4.4-1.3 6.7h-1s-1.2-4.7.7-7.4a10 10 0 00.9-10.2 12.6 12.6 0 00-4.5-5.4c-3.1 1.3-9.7 0-11.5-1.3-1.8-1.3-2.8-3.1.7-3.3 3.4-.2 9.3-.1 13.3 3 0 0 2-2.5 12.6-1.3 10.4 1.1 18 5.6 20.3 15 1.2 4.8-3.2 14.9-7.3 17.3 0 0 0-1.6-.3-2.8 0 0 7-7.8 4.9-15.1-2.1-7.3-10.5-12-19.6-11.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path592",
    fill: "#fff",
    d: "M308 194.3c-1.8-.1-3.2-.4-3.2-.7 0-.2 1.5-.3 3.3-.2 1.8.2 3.3.5 3.3.7 0 .3-1.5.4-3.4.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path593",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.7,
    d: "M314.6 196s2.1 2 0 0c-2-1.9-6.4-3.2-8.8-2.6-2.5.5.4.8 1.2.9.9 0 2.5.4 4.9 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path594",
    fill: "#fc0",
    fillOpacity: 1,
    d: "M291.1 189.3v22.3c-.2 2.2 2.7 5.3 4.8 6.2 0 0 5-1.6 5.3-6.2v-23.5h-1.7v20.4c0 2-1.4 5.8-3.3 6.4 0 0-3.6-.6-3.8-6.4v-19.8l-1.3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path595",
    fill: "#bcac0b",
    fillOpacity: 1,
    stroke: "#000",
    strokeWidth: 0.7,
    d: "M291.1 189.3v22.3c-.2 2.2 2.7 5.3 4.8 6.2 0 0 5-1.6 5.3-6.2v-23.5h-1.7v20.4c0 2-1.4 5.8-3.3 6.4 0 0-3.6-.6-3.8-6.4v-19.8l-1.3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path596",
    fill: "#fff",
    d: "M241.8 219.8a2.7 2.7 0 100-5.3 2.7 2.7 0 000 5.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path597",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1,
    d: "M241.8 219.8a2.7 2.7 0 100-5.3 2.7 2.7 0 000 5.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path598",
    fill: "#fff",
    d: "M240.1 213.7a2.7 2.7 0 100-5.3 2.7 2.7 0 000 5.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path599",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1,
    d: "M240.1 213.7a2.7 2.7 0 100-5.3 2.7 2.7 0 000 5.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path600",
    fill: "#fff",
    d: "M241 206.3a2.7 2.7 0 100-5.3 2.7 2.7 0 000 5.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path601",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1,
    d: "M241 206.3a2.7 2.7 0 100-5.3 2.7 2.7 0 000 5.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path602",
    fill: "#fff",
    d: "M245.1 200.1a2.7 2.7 0 100-5.3 2.7 2.7 0 000 5.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path603",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1,
    d: "M245.1 200.1a2.7 2.7 0 100-5.3 2.7 2.7 0 000 5.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path604",
    fill: "#fff",
    d: "M250 195.6a2.7 2.7 0 100-5.3 2.7 2.7 0 000 5.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path605",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1,
    d: "M250 195.6a2.7 2.7 0 100-5.3 2.7 2.7 0 000 5.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path606",
    fill: "#fff",
    d: "M256.4 193.1a2.7 2.7 0 100-5.3 2.7 2.7 0 000 5.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path607",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1,
    d: "M256.4 193.1a2.7 2.7 0 100-5.3 2.7 2.7 0 000 5.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path608",
    fill: "#fff",
    d: "M263 192a2.7 2.7 0 100-5.4 2.7 2.7 0 000 5.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path609",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1,
    d: "M263 192a2.7 2.7 0 100-5.4 2.7 2.7 0 000 5.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path610",
    fill: "#fff",
    d: "M269.3 191.6a2.7 2.7 0 100-5.4 2.7 2.7 0 000 5.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path611",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1,
    d: "M269.3 191.6a2.7 2.7 0 100-5.4 2.7 2.7 0 000 5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path612",
    fill: "#fff",
    d: "M275 192a2.7 2.7 0 100-5.3 2.7 2.7 0 000 5.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path613",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1,
    d: "M275 192a2.7 2.7 0 100-5.3 2.7 2.7 0 000 5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path614",
    fill: "#fff",
    d: "M291 190a2.7 2.7 0 100-5.3 2.7 2.7 0 000 5.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path615",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1,
    d: "M291 190a2.7 2.7 0 100-5.3 2.7 2.7 0 000 5.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path616",
    fill: "#fff",
    d: "M296.2 191.4a2.7 2.7 0 100-5.3 2.7 2.7 0 000 5.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path617",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1,
    d: "M296.2 191.4a2.7 2.7 0 100-5.3 2.7 2.7 0 000 5.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path618",
    fill: "#fff",
    d: "M296.2 211.2a2.7 2.7 0 100-5.4 2.7 2.7 0 000 5.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path619",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1,
    d: "M296.2 211.2a2.7 2.7 0 100-5.4 2.7 2.7 0 000 5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path620",
    fill: "#fff",
    d: "M351.3 221.5a2.7 2.7 0 100-5.3 2.7 2.7 0 000 5.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path621",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1,
    d: "M351.3 221.5a2.7 2.7 0 100-5.3 2.7 2.7 0 000 5.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path622",
    fill: "#fff",
    d: "M352.7 215a2.7 2.7 0 100-5.4 2.7 2.7 0 000 5.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path623",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1,
    d: "M352.7 215a2.7 2.7 0 100-5.4 2.7 2.7 0 000 5.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path624",
    fill: "#fff",
    d: "M351.6 208a2.7 2.7 0 100-5.3 2.7 2.7 0 000 5.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path625",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1,
    d: "M351.6 208a2.7 2.7 0 100-5.3 2.7 2.7 0 000 5.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path626",
    fill: "#fff",
    d: "M348.7 201.5a2.7 2.7 0 100-5.4 2.7 2.7 0 000 5.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path627",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1,
    d: "M348.7 201.5a2.7 2.7 0 100-5.4 2.7 2.7 0 000 5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path628",
    fill: "#fff",
    d: "M343.8 197a2.7 2.7 0 100-5.4 2.7 2.7 0 000 5.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path629",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1,
    d: "M343.8 197a2.7 2.7 0 100-5.4 2.7 2.7 0 000 5.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path630",
    fill: "#fff",
    d: "M337.9 194a2.7 2.7 0 100-5.3 2.7 2.7 0 000 5.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path631",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1,
    d: "M337.9 194a2.7 2.7 0 100-5.3 2.7 2.7 0 000 5.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path632",
    fill: "#fff",
    d: "M331.1 192.5a2.7 2.7 0 100-5.3 2.7 2.7 0 000 5.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path633",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1,
    d: "M331.1 192.5a2.7 2.7 0 100-5.3 2.7 2.7 0 000 5.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path634",
    fill: "#fff",
    d: "M325 192a2.7 2.7 0 100-5.3 2.7 2.7 0 000 5.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path635",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1,
    d: "M325 192a2.7 2.7 0 100-5.3 2.7 2.7 0 000 5.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path636",
    fill: "#fff",
    d: "M319.4 191.3a2.7 2.7 0 100-5.4 2.7 2.7 0 000 5.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path637",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1,
    d: "M319.4 191.3a2.7 2.7 0 100-5.4 2.7 2.7 0 000 5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path638",
    fill: "#fff",
    d: "M323 213a2.7 2.7 0 100-5.3 2.7 2.7 0 000 5.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path639",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1,
    d: "M323 213a2.7 2.7 0 100-5.3 2.7 2.7 0 000 5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path640",
    fill: "#fff",
    d: "M324.4 208a2.7 2.7 0 100-5.4 2.7 2.7 0 000 5.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path641",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1,
    d: "M324.4 208a2.7 2.7 0 100-5.4 2.7 2.7 0 000 5.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path642",
    fill: "#fff",
    d: "M302 190.9a2.7 2.7 0 100-5.4 2.7 2.7 0 000 5.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path643",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1,
    d: "M302 190.9a2.7 2.7 0 100-5.4 2.7 2.7 0 000 5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path644",
    fill: "#fff",
    d: "M289 190.1a2.7 2.7 0 100-5.3 2.7 2.7 0 000 5.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path645",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1,
    d: "M289 190.1a2.7 2.7 0 100-5.3 2.7 2.7 0 000 5.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path646",
    fill: "#fff",
    d: "M285.8 190a2.7 2.7 0 100-5.3 2.7 2.7 0 000 5.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path647",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1,
    d: "M285.8 190a2.7 2.7 0 100-5.3 2.7 2.7 0 000 5.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path648",
    fill: "#fff",
    d: "M268.8 213.1a2.7 2.7 0 100-5.3 2.7 2.7 0 000 5.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path649",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1,
    d: "M268.8 213.1a2.7 2.7 0 100-5.3 2.7 2.7 0 000 5.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path650",
    fill: "#fff",
    d: "M268 206.8a2.7 2.7 0 100-5.4 2.7 2.7 0 000 5.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path651",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1,
    d: "M268 206.8a2.7 2.7 0 100-5.4 2.7 2.7 0 000 5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path652",
    fill: "#fff",
    d: "M270 200.6a2.7 2.7 0 100-5.3 2.7 2.7 0 000 5.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path653",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1,
    d: "M270 200.6a2.7 2.7 0 100-5.3 2.7 2.7 0 000 5.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path654",
    fill: "#fff",
    d: "M281.7 190.6a2.7 2.7 0 100-5.3 2.7 2.7 0 000 5.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path655",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1,
    d: "M281.7 190.6a2.7 2.7 0 100-5.3 2.7 2.7 0 000 5.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path656",
    fill: "#fff",
    d: "M277.2 192.4a2.7 2.7 0 100-5.3 2.7 2.7 0 000 5.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path657",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1,
    d: "M277.2 192.4a2.7 2.7 0 100-5.3 2.7 2.7 0 000 5.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path658",
    fill: "#fff",
    d: "M273 196a2.7 2.7 0 100-5.3 2.7 2.7 0 000 5.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path659",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1,
    d: "M273 196a2.7 2.7 0 100-5.3 2.7 2.7 0 000 5.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path660",
    fill: "#fff",
    d: "M296.2 194.4a2.7 2.7 0 100-5.3 2.7 2.7 0 000 5.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path661",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1,
    d: "M296.2 194.4a2.7 2.7 0 100-5.3 2.7 2.7 0 000 5.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path662",
    fill: "#fff",
    d: "M296.2 199.5a2.7 2.7 0 100-5.4 2.7 2.7 0 000 5.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path663",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1,
    d: "M296.2 199.5a2.7 2.7 0 100-5.4 2.7 2.7 0 000 5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path664",
    fill: "#fff",
    d: "M296.2 204.9a2.7 2.7 0 100-5.4 2.7 2.7 0 000 5.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path665",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1,
    d: "M296.2 204.9a2.7 2.7 0 100-5.4 2.7 2.7 0 000 5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path666",
    fill: "#fff",
    d: "M305.4 190.2a2.7 2.7 0 100-5.4 2.7 2.7 0 000 5.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path667",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1,
    d: "M305.4 190.2a2.7 2.7 0 100-5.4 2.7 2.7 0 000 5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path668",
    fill: "#fff",
    d: "M309 189.4a2.7 2.7 0 100-5.3 2.7 2.7 0 000 5.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path669",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1,
    d: "M309 189.4a2.7 2.7 0 100-5.3 2.7 2.7 0 000 5.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path670",
    fill: "#fff",
    d: "M313.2 190a2.7 2.7 0 100-5.3 2.7 2.7 0 000 5.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path671",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1,
    d: "M313.2 190a2.7 2.7 0 100-5.3 2.7 2.7 0 000 5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path672",
    fill: "#fff",
    d: "M323.5 201.4a2.7 2.7 0 100-5.3 2.7 2.7 0 000 5.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path673",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1,
    d: "M323.5 201.4a2.7 2.7 0 100-5.3 2.7 2.7 0 000 5.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path674",
    fill: "#fff",
    d: "M317.3 192.5a2.7 2.7 0 100-5.4 2.7 2.7 0 000 5.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path675",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1,
    d: "M317.3 192.5a2.7 2.7 0 100-5.4 2.7 2.7 0 000 5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path676",
    fill: "#fff",
    d: "M321.1 196.1a2.7 2.7 0 100-5.3 2.7 2.7 0 000 5.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path677",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1,
    d: "M321.1 196.1a2.7 2.7 0 100-5.3 2.7 2.7 0 000 5.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path678",
    fill: "#fff",
    d: "M296 236l-7 3.6 6.3 4 7.5-3.8-6.8-3.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path679",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.5,
    d: "M296 236l-7 3.6 6.3 4 7.5-3.8-6.8-3.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path680",
    fill: "#fff",
    d: "M280.6 236.8l-10.5 1.6s-.2 5.7.3 7l10.9-1.4s.5-5.3-.7-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path681",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.5,
    d: "M280.6 236.8l-10.5 1.6s-.2 5.7.3 7l10.9-1.4s.5-5.3-.7-7.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path682",
    fill: "#058e6e",
    fillOpacity: 0.9,
    d: "M279.5 238.8s-6.4.6-8 1.2v3.8s4.3-.7 8.1-1l-.1-4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path683",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.5,
    d: "M279.5 238.8s-6.4.6-8 1.2v3.8s4.3-.7 8.1-1l-.1-4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path684",
    fill: "#fff",
    d: "M310.7 237l10.6 1.7s.1 5.7-.4 7l-10.8-1.4s-.5-5.3.6-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path685",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.5,
    d: "M310.7 237l10.6 1.7s.1 5.7-.4 7l-10.8-1.4s-.5-5.3.6-7.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path686",
    fill: "#058e6e",
    fillOpacity: 0.9,
    d: "M312 239.1s6.3.6 7.9 1.2l-.1 3.8s-4.2-.7-8-1l.1-4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path687",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.5,
    d: "M312 239.1s6.3.6 7.9 1.2l-.1 3.8s-4.2-.7-8-1l.1-4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path688",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.5,
    d: "M254.2 241.8s37-13.7 84.2 1.2m-82.7 6.7s35.9-13.4 80 .6m-79.8-9l7.2 2.1-5 5.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path689",
    fill: "red",
    d: "M256 247.8l4.2-3.5-4.7-.9s.6.7.5 1.4v3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path690",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.5,
    d: "M256 247.8l4.2-3.5-4.7-.9s.6.7.5 1.4v3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path691",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.5,
    d: "M337.6 242.7l-7.7 1.4 5.2 6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path692",
    fill: "red",
    d: "M335.3 248l-2.9-3 4.2-.4s-1.2.7-1.2 1.4c0 .6.2 1.5 0 2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path693",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.5,
    d: "M335.3 248l-2.9-3 4.2-.4s-1.2.7-1.2 1.4c0 .6.2 1.5 0 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path694",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.5,
    d: "M265.3 241.8c.6 0 1.2-.4 1.2-1 0-.4-.6-.9-1.2-.9-.7 0-1.2.5-1.2 1s.5 1 1.2 1zm20.6-2.3c.7 0 1.2-.4 1.2-1 0-.5-.5-.9-1.2-.9s-1.2.4-1.2 1c0 .5.5.9 1.2.9zm0 3.3c.7 0 1.2-.4 1.2-.9s-.5-1-1.2-1-1.2.5-1.2 1 .5 1 1.2 1zm20.3-3.1c.6 0 1.2-.5 1.2-1s-.6-1-1.2-1c-.7 0-1.2.5-1.2 1s.5 1 1.2 1zm20.1 3.7c.7 0 1.2-.5 1.2-1s-.5-1-1.2-1-1.2.5-1.2 1 .5 1 1.2 1zm-.3 2.6c.6 0 1.2-.4 1.2-1 0-.4-.6-.9-1.2-.9-.7 0-1.2.5-1.2 1s.5 1 1.2 1zm-19.8-3c.6 0 1.2-.4 1.2-1 0-.5-.6-.9-1.2-.9-.7 0-1.2.4-1.2 1 0 .5.5 1 1.2 1zm-40 3c.7 0 1.3-.4 1.3-1 0-.4-.6-.9-1.2-.9-.7 0-1.2.5-1.2 1s.5 1 1.2 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path695",
    fill: "#fc0",
    fillOpacity: 1,
    d: "M253.6 231s.1 7.2 4.8 6.2 4.2-6.9 4.5-7.2c.4-.3.9-.3.9-.3s.6 5.7 5 5c4.4-.7 4.2-7.7 3.7-8.9l1-.3s1.7 8.2 6.7 7c5-1.2 4.5-6.4 4.5-6.4h.4s1.1 5.6 5.2 5.2c4-.3 4.8-1.6 4.3-7.2l2.7-.5s-1 8 3.9 8c4.8-.3 5-4.1 5.3-4.8h.8s.2 5.7 4.3 5.7c4 0 4.8-4.8 4.8-6.7l4 .2s-4.2 7.5 1.9 8.5c6 1 6.2-4.8 6.2-4.8h1.2s-.2 7.5 3.1 7.7c3.4.1 5.4-1 5.7-6.6l1.9.7s-1.6 9-7.9 7.4c-3.3-.9-4.4-4.7-4.2-5.7 0 0-2.3 4.2-6.9 2.8-4.5-1.3-4-4.5-4-5.5 0 0-2.7 5-6.5 3.9-3.4-1-4.7-2.2-4.7-4.6 0 0-1.7 3.9-5 3.7-3.4-.1-5-2.2-5.2-4 0 0-.7 3.6-5.2 3.9-3 .1-4.7-1.4-5.4-3.4 0 0-.9 3.6-5.2 4.2-2.7.3-5.4-1.2-6-3.7 0 0-.7 4.9-5 5.5-4.4.7-5.4-2.3-5.4-2.3s-.9 3.8-4.4 4.7c-3.5.8-5.8-.7-6.7-4.2-.8-3.5-.5-5-.5-5l1.4 1.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path696",
    fill: "#bcac0b",
    fillOpacity: 1,
    stroke: "#000",
    strokeWidth: 0.7,
    d: "M253.6 231s.1 7.2 4.8 6.2 4.2-6.9 4.5-7.2c.4-.3.9-.3.9-.3s.6 5.7 5 5c4.4-.7 4.2-7.7 3.7-8.9l1-.3s1.7 8.2 6.7 7c5-1.2 4.5-6.4 4.5-6.4h.4s1.1 5.6 5.2 5.2c4-.3 4.8-1.6 4.3-7.2l2.7-.5s-1 8 3.9 8c4.8-.3 5-4.1 5.3-4.8h.8s.2 5.7 4.3 5.7c4 0 4.8-4.8 4.8-6.7l4 .2s-4.2 7.5 1.9 8.5c6 1 6.2-4.8 6.2-4.8h1.2s-.2 7.5 3.1 7.7c3.4.1 5.4-1 5.7-6.6l1.9.7s-1.6 9-7.9 7.4c-3.3-.9-4.4-4.7-4.2-5.7 0 0-2.3 4.2-6.9 2.8-4.5-1.3-4-4.5-4-5.5 0 0-2.7 5-6.5 3.9-3.4-1-4.7-2.2-4.7-4.6 0 0-1.7 3.9-5 3.7-3.4-.1-5-2.2-5.2-4 0 0-.7 3.6-5.2 3.9-3 .1-4.7-1.4-5.4-3.4 0 0-.9 3.6-5.2 4.2-2.7.3-5.4-1.2-6-3.7 0 0-.7 4.9-5 5.5-4.4.7-5.4-2.3-5.4-2.3s-.9 3.8-4.4 4.7c-3.5.8-5.8-.7-6.7-4.2-.8-3.5-.5-5-.5-5l1.4 1.8h0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path697",
    fill: "#fc0",
    fillOpacity: 1,
    d: "M263.3 231.3a1.7 1.7 0 100-3.3 1.7 1.7 0 000 3.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path698",
    fill: "#bcac0b",
    fillOpacity: 1,
    stroke: "#000",
    strokeWidth: 0.7,
    d: "M263.3 231.3a1.7 1.7 0 100-3.3 1.7 1.7 0 000 3.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path699",
    fill: "#fc0",
    fillOpacity: 1,
    d: "M285.1 227.8a1.7 1.7 0 100-3.3 1.7 1.7 0 000 3.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path700",
    fill: "#bcac0b",
    fillOpacity: 1,
    stroke: "#000",
    strokeWidth: 0.7,
    d: "M285.1 227.8a1.7 1.7 0 100-3.3 1.7 1.7 0 000 3.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path701",
    fill: "#fc0",
    fillOpacity: 1,
    d: "M307.3 228.5a1.7 1.7 0 100-3.3 1.7 1.7 0 000 3.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path702",
    fill: "#bcac0b",
    fillOpacity: 1,
    stroke: "#000",
    strokeWidth: 0.7,
    d: "M307.3 228.5a1.7 1.7 0 100-3.3 1.7 1.7 0 000 3.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path703",
    fill: "#fc0",
    fillOpacity: 1,
    d: "M329.2 232a1.7 1.7 0 100-3.3 1.7 1.7 0 000 3.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path704",
    fill: "#bcac0b",
    fillOpacity: 1,
    stroke: "#000",
    strokeWidth: 0.7,
    d: "M329.2 232a1.7 1.7 0 100-3.3 1.7 1.7 0 000 3.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path705",
    fill: "#fc0",
    fillOpacity: 1,
    d: "M295.2 226h-1.5c-.4 1.5-3.6 2.4-3.6 2.4-.4-1.2.5-2.9.5-2.9-3.7-1-3.7-2.2-3.7-2.2.5-1.3 4-1.5 4-1.5-1-1.1-.8-3-.8-3 2.3.2 4.2 2.5 4.2 2.5s-2.3-1.2-2-5.2c0 0 1.2 0 2 .8 0 0 0-4.4 1.8-4.9h.2c1.8.5 1.8 4.9 1.8 4.9.8-.9 2-.8 2-.8.3 4-2 5.2-2 5.2s1.9-2.3 4.2-2.4c0 0 .1 1.8-.7 3 0 0 3.4.1 4 1.4 0 0 0 1.3-3.8 2.2 0 0 .8 1.7.5 3 0 0-3.3-1-3.6-2.5h-3.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path706",
    fill: "#bcac0b",
    fillOpacity: 1,
    stroke: "#000",
    strokeWidth: 0.7,
    d: "M295.2 226h-1.5c-.4 1.5-3.6 2.4-3.6 2.4-.4-1.2.5-2.9.5-2.9-3.7-1-3.7-2.2-3.7-2.2.5-1.3 4-1.5 4-1.5-1-1.1-.8-3-.8-3 2.3.2 4.2 2.5 4.2 2.5s-2.3-1.2-2-5.2c0 0 1.2 0 2 .8 0 0 0-4.4 1.8-4.9h.2c1.8.5 1.8 4.9 1.8 4.9.8-.9 2-.8 2-.8.3 4-2 5.2-2 5.2s1.9-2.3 4.2-2.4c0 0 .1 1.8-.7 3 0 0 3.4.1 4 1.4 0 0 0 1.3-3.8 2.2 0 0 .8 1.7.5 3 0 0-3.3-1-3.6-2.5h-3.5 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path707",
    fill: "#fff",
    d: "M296 226.8a3 3 0 100-6 3 3 0 000 6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path708",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M296 226.8a3 3 0 100-6 3 3 0 000 6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path709",
    fill: "#fff",
    d: "M296 225.5a1.7 1.7 0 100-3.4 1.7 1.7 0 000 3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path710",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M296 225.5a1.7 1.7 0 100-3.4 1.7 1.7 0 000 3.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path711",
    fill: "#fc0",
    fillOpacity: 1,
    d: "M319.1 228l1.5.3c0 1.5 3 3.1 3 3.1.6-1 .1-2.9.1-2.9 3.9-.1 4.1-1.4 4.1-1.4-.2-1.4-3.5-2.3-3.5-2.3 1-.9 1.3-2.7 1.3-2.7-2.3-.4-4.6 1.4-4.6 1.4s2.5-.6 3-4.6c0 0-1.1-.3-2 .3 0 0 .9-4.2-.8-5l-.2-.1c-1.9 0-2.8 4.3-2.8 4.3-.6-1-1.8-1.1-1.8-1.1-1.1 3.8.9 5.4.9 5.4s-1.4-2.6-3.6-3.2c0 0-.5 1.8 0 3 0 0-3.3-.5-4.1.6 0 0-.3 1.3 3.1 3 0 0-1.1 1.5-1 2.8 0 0 3.3-.3 4-1.7l1.5.3 2 .4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path712",
    fill: "#bcac0b",
    fillOpacity: 1,
    stroke: "#000",
    strokeWidth: 0.7,
    d: "M319.1 228l1.5.3c0 1.5 3 3.1 3 3.1.6-1 .1-2.9.1-2.9 3.9-.1 4.1-1.4 4.1-1.4-.2-1.4-3.5-2.3-3.5-2.3 1-.9 1.3-2.7 1.3-2.7-2.3-.4-4.6 1.4-4.6 1.4s2.5-.6 3-4.6c0 0-1.1-.3-2 .3 0 0 .9-4.2-.8-5l-.2-.1c-1.9 0-2.8 4.3-2.8 4.3-.6-1-1.8-1.1-1.8-1.1-1.1 3.8.9 5.4.9 5.4s-1.4-2.6-3.6-3.2c0 0-.5 1.8 0 3 0 0-3.3-.5-4.1.6 0 0-.3 1.3 3.1 3 0 0-1.1 1.5-1 2.8 0 0 3.3-.3 4-1.7l1.5.3 2 .4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path713",
    fill: "#fff",
    d: "M318 228.6a3 3 0 111.4-6 3 3 0 01-1.3 6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path714",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M318 228.6a3 3 0 111.4-6 3 3 0 01-1.3 6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path715",
    fill: "#fff",
    d: "M318.4 227.3a1.7 1.7 0 11.7-3.3 1.7 1.7 0 01-.7 3.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path716",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M318.4 227.3a1.7 1.7 0 11.7-3.3 1.7 1.7 0 01-.7 3.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path717",
    fill: "#fc0",
    fillOpacity: 1,
    d: "M272.3 227.6l-1.5.2c-.2 1.6-3.3 3-3.3 3-.5-1.2 0-3 0-3-3.7-.4-3.9-1.7-3.9-1.7.4-1.3 3.8-2 3.8-2-1-1-1.1-2.8-1.1-2.8 2.2-.2 4.4 1.8 4.4 1.8s-2.4-.8-2.7-4.8c0 0 1.3-.3 2.1.4 0 0-.5-4.3 1.2-5h.2c1.9.2 2.4 4.5 2.4 4.5.7-.9 2-1 2-1 .7 4-1.4 5.4-1.4 5.4s1.6-2.5 3.8-3c0 0 .4 1.9-.3 3.1 0 0 3.4-.3 4.1 1 0 0 .2 1.2-3.4 2.6 0 0 1 1.6.9 2.8 0 0-3.3-.5-4-2l-1.4.3-2 .2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path718",
    fill: "#bcac0b",
    fillOpacity: 1,
    stroke: "#000",
    strokeWidth: 0.7,
    d: "M272.3 227.6l-1.5.2c-.2 1.6-3.3 3-3.3 3-.5-1.2 0-3 0-3-3.7-.4-3.9-1.7-3.9-1.7.4-1.3 3.8-2 3.8-2-1-1-1.1-2.8-1.1-2.8 2.2-.2 4.4 1.8 4.4 1.8s-2.4-.8-2.7-4.8c0 0 1.3-.3 2.1.4 0 0-.5-4.3 1.2-5h.2c1.9.2 2.4 4.5 2.4 4.5.7-.9 2-1 2-1 .7 4-1.4 5.4-1.4 5.4s1.6-2.5 3.8-3c0 0 .4 1.9-.3 3.1 0 0 3.4-.3 4.1 1 0 0 .2 1.2-3.4 2.6 0 0 1 1.6.9 2.8 0 0-3.3-.5-4-2l-1.4.3-2 .2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path719",
    fill: "#fff",
    d: "M273.2 228.4a3 3 0 10-.8-6 3 3 0 00.8 6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path720",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M273.2 228.4a3 3 0 10-.8-6 3 3 0 00.8 6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path721",
    fill: "#fff",
    d: "M273 227a1.7 1.7 0 10-.4-3.3 1.7 1.7 0 00.4 3.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path722",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M273 227a1.7 1.7 0 10-.4-3.3 1.7 1.7 0 00.4 3.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path723",
    fill: "#fc0",
    fillOpacity: 1,
    d: "M340.2 234.1s-.8-2-2.5-1.3-1.5 1-3 1c0 0-.6-1.9.2-2.7 0 0-2.4-.9-3-3 0 0 1.3-1.5 4.4-.9 0 0-.1-1.5.3-2.2 0 0 3.3 1 3.3 2.9 0 0-1-3.6.8-6.2 0 0 1.5.6 1.4 2.3 0 0 .7-3.4 5.2-2.5 0 0-2.4 2.2-2.5 3.2-.2 1-2.2 2.7-2.3 3.3 0 .5-.2 1.5-.8 2.1-.6.6-.7 1.6-.7 2 0 .2 0 1.6-.8 2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path724",
    fill: "#bcac0b",
    fillOpacity: 1,
    stroke: "#000",
    strokeWidth: 0.7,
    d: "M340.2 234.1s-.8-2-2.5-1.3-1.5 1-3 1c0 0-.6-1.9.2-2.7 0 0-2.4-.9-3-3 0 0 1.3-1.5 4.4-.9 0 0-.1-1.5.3-2.2 0 0 3.3 1 3.3 2.9 0 0-1-3.6.8-6.2 0 0 1.5.6 1.4 2.3 0 0 .7-3.4 5.2-2.5 0 0-2.4 2.2-2.5 3.2-.2 1-2.2 2.7-2.3 3.3 0 .5-.2 1.5-.8 2.1-.6.6-.7 1.6-.7 2 0 .2 0 1.6-.8 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path725",
    fill: "#fff",
    d: "M337.7 230.1a3 3 0 014.8-1.8c0 .5-.3 1.3-.8 1.8-.6.6-.7 1.6-.7 2a3 3 0 01-.4 1.6h-.5a3 3 0 01-2.4-3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path726",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M337.7 230.1a3 3 0 014.8-1.8c0 .5-.3 1.3-.8 1.8-.6.6-.7 1.6-.7 2a3 3 0 01-.4 1.6h-.5a3 3 0 01-2.4-3.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path727",
    fill: "#fff",
    d: "M339 230.4a1.7 1.7 0 013-.7l-.3.4c-.6.6-.7 1.6-.7 2v.2h-.6c-1-.1-1.5-1-1.3-2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path728",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M339 230.4a1.7 1.7 0 013-.7l-.3.4c-.6.6-.7 1.6-.7 2v.2h-.6c-1-.1-1.5-1-1.3-2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path729",
    fill: "#fc0",
    fillOpacity: 1,
    d: "M252.2 233.3s.8-2 2.5-1.2c1.6.9 1.4 1.1 3 1.1 0 0 .6-1.8 0-2.6 0 0 2.4-.7 3-2.8 0 0-1.2-1.6-4.3-1.2 0 0 .2-1.5-.2-2.2 0 0-3.3.8-3.4 2.6 0 0 1.2-3.5-.4-6.2 0 0-1.6.6-1.6 2.2 0 0-.5-3.4-5-2.7 0 0 2.3 2.3 2.3 3.3s2 2.8 2 3.4c0 .5.2 1.6.8 2.2.6.6.6 1.6.5 2 0 .2 0 1.6.8 2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path730",
    fill: "#bcac0b",
    fillOpacity: 1,
    stroke: "#000",
    strokeWidth: 0.7,
    d: "M252.2 233.3s.8-2 2.5-1.2c1.6.9 1.4 1.1 3 1.1 0 0 .6-1.8 0-2.6 0 0 2.4-.7 3-2.8 0 0-1.2-1.6-4.3-1.2 0 0 .2-1.5-.2-2.2 0 0-3.3.8-3.4 2.6 0 0 1.2-3.5-.4-6.2 0 0-1.6.6-1.6 2.2 0 0-.5-3.4-5-2.7 0 0 2.3 2.3 2.3 3.3s2 2.8 2 3.4c0 .5.2 1.6.8 2.2.6.6.6 1.6.5 2 0 .2 0 1.6.8 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path731",
    fill: "#fff",
    d: "M254.8 229.4a3 3 0 00-4.6-2c0 .5.2 1.3.7 1.8.6.6.6 1.6.5 2 0 .2 0 1 .4 1.7h.4a3 3 0 002.6-3.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path732",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M254.8 229.4a3 3 0 00-4.6-2c0 .5.2 1.3.7 1.8.6.6.6 1.6.5 2 0 .2 0 1 .4 1.7h.4a3 3 0 002.6-3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path733",
    fill: "#fff",
    d: "M253.5 229.6a1.7 1.7 0 00-3-.9l.4.5c.6.6.6 1.6.5 2v.2h.7c.9 0 1.5-.9 1.4-1.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path734",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M253.5 229.6a1.7 1.7 0 00-3-.9l.4.5c.6.6.6 1.6.5 2v.2h.7c.9 0 1.5-.9 1.4-1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path735",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.5,
    d: "M257.2 251.6s33.8-13.2 76.4.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path736",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.5,
    d: "M338.4 241.1c-47.1-15-84.7-.8-84.7-.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path737",
    fill: "red",
    d: "M296 237.8l-3.8 1.9 3.4 2.1 4-2-3.6-2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path738",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.5,
    d: "M296 237.8l-3.8 1.9 3.4 2.1 4-2-3.6-2"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsGa);
export default __webpack_public_path__ + "static/media/es-ga.405f191245cb5d0085d789f338a16d67.svg";
export { ForwardRef as ReactComponent };